import { useEffect, useState } from 'react'
import { assetSrc } from '../../media/media-asset.util'
import { gameCollectionHeadingBgMap, getTemplate } from '../../media/template-loader'

type Props = {
  headingContent?: string
  headingTextColor?: string
  headingBgImageTemplate?: string
}

export function GameCollectionHeader(props: Props) {
  const { headingContent, headingTextColor = '#FFFFFF', headingBgImageTemplate = 'gameCollectionHeadingBgDefault01' } = props

  const [imageHeight, setImageHeight] = useState(0)

  const template = getTemplate(gameCollectionHeadingBgMap, headingBgImageTemplate)
  const imgSrc = assetSrc(template)

  useEffect(() => {
    const img = new Image()
    img.src = imgSrc
    img.onload = () => {
      setImageHeight(img.naturalHeight)
    }
  }, [imgSrc])

  return (
    <div className="relative bg-center bg-no-repeat" style={{ backgroundImage: `url(${imgSrc})`, height: imageHeight }}>
      <p
        className="absolute top-1/3 w-full -translate-y-1/3 text-center text-[30px]/[36px] font-bold"
        style={{
          textShadow: '0 4px 4px rgba(0, 0, 0, 0.25)',
          color: headingTextColor,
        }}
      >
        {headingContent}
      </p>
    </div>
  )
}
